import * as React from "react";
import { forwardRef } from "react";
const SvgKeyboardArrowDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.175 7.15833L10 10.975L13.825 7.15833L15 8.33333L10 13.3333L5 8.33333L6.175 7.15833Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgKeyboardArrowDown);
export default ForwardRef;
